import {KFZ_ACTIONS} from "./types";
import {addProcessing, removeProcessing} from "./processingActions";
import {PROC_KFZ, PROC_KFZ_FETCH, PROC_KFZ_UPLOAD, UPDATE_KFZ} from "./index";
import {addError} from "./errorActions";
import isFunc from 'lodash/isFunction';
import {shouldUpdateExtend} from "ith-redux-helpers";
import {DELETE, GET, POST, PUT, UPLOAD} from "ith-fetch";
import omit from 'lodash/omit';

const _set = (list, cache=true) => ({type: KFZ_ACTIONS.SET, list, cache});
const _remove = (kfz_id, cache=false) => ({type: KFZ_ACTIONS.REMOVE, kfz_id, cache});
const _setModels = (kfz_id, models, cache=false) => ({type: KFZ_ACTIONS.SET_MODELS, kfz_id, models, cache});
const _removeModel = (kfz_id, model, cache=false) => ({type: KFZ_ACTIONS.REMOVE_MODEL, kfz_id, model, cache});

export const fetchKfzList = (kfz_id = null, force=false, onSuccess) =>
	async (dispatch, getState) => {
		const kfz = getState().kfz;
		console.info('Fetch kfz list: ', force);
		if (!force && !shouldUpdateExtend(kfz, UPDATE_KFZ)) {
			console.debug('fetching kfz list is cached...');
			isFunc(onSuccess && onSuccess(kfz.list));
			return;
		}
		try {
			dispatch(addProcessing(PROC_KFZ_FETCH));
			const append = kfz_id ? '/' + kfz_id : '';
			const list = await GET('/kfz' + append);
			dispatch(_set(list, !kfz_id));
			isFunc(onSuccess) && onSuccess(list);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_FETCH));
		}
	};
export const createKfz = (kfz_data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_KFZ));
			const kfz = await PUT('/kfz', kfz_data);
			dispatch(_set([kfz], false));
			isFunc(onSuccess) && onSuccess(kfz);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ));
		}
	};
export const updateKfz = (kfz_data, onSuccess) =>
	async dispatch => {
		try {
			const kfz = omit(kfz_data, ['models', 'last_updated']);
			dispatch(addProcessing(PROC_KFZ, kfz_data.kfz_id));
			const res = await POST('/kfz', kfz);
			dispatch(_set([res], false));
			isFunc(onSuccess) && onSuccess(res);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, kfz_data.kfz_id));
		}
	};
export const deleteKfz = (kfz_data, onSuccess) =>
	async dispatch => {
		const kfz_id = kfz_data.kfz_id || kfz_data;
		try {
			dispatch(addProcessing(PROC_KFZ, kfz_id));
			const result = await DELETE('/kfz/' + kfz_id);
			dispatch(_remove(kfz_id));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, kfz_id));
		}
	};

export const fetchKfzModels = (kfz, force=false, onSuccess) =>
	async (dispatch, getState) => {
		const kfz_id = kfz.kfz_id || kfz;
		try {
			dispatch(addProcessing(PROC_KFZ, kfz_id));
			const result = await GET('/kfz/models/' + kfz_id);
			dispatch(_setModels(result.kfz_id, result.models, true));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, kfz_id));
		}
	};
export const createKfzModel = (kfz, model, onSuccess) =>
	async dispatch => {
		const kfz_id = kfz.kfz_id || kfz;
		try {
			dispatch(addProcessing(PROC_KFZ, kfz_id));
			const result = await PUT('/kfz/model/' + kfz_id, model);
			dispatch(_setModels(kfz_id, [result.model]));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, kfz_id));
		}
	};
export const deleteKfzModel = (kfz, hsn, tsn, onSuccess) =>
	async dispatch => {
		const kfz_id = kfz.kfz_id || kfz;
		try {
			dispatch(addProcessing(PROC_KFZ, kfz_id));
			const result = await DELETE (`/kfz/model/${kfz_id}/${hsn}/${tsn}`);
			dispatch(_removeModel(kfz_id, result.deleted));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, kfz_id));
		}
	};
export const updateKfzModel = (model, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_KFZ, model.kfz_id));
			const result = await POST('/kfz/model', model);
			dispatch(_setModels(model.kfz_id, [result.model]));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ, model.kfz_id));
		}
	};
export const uploadLogoForKfz = (kfz, image, onSuccess) =>
	async dispatch => {
		const kfz_id = kfz.kfz_id || kfz;
		const data = new FormData();
		data.append('file', image);
		try {
			dispatch(addProcessing(PROC_KFZ_UPLOAD, kfz_id));
			const result = await UPLOAD('/kfz/logo/' + kfz_id, data);
			dispatch(_set([result.kfz], false));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_KFZ_UPLOAD, kfz_id));
		}
	};


// WEBPACK FOOTER //
// ./src/actions/kfzActions.js